import { useEffect as __mpUseEffect, useState as __mpUseState } from "react";
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initMetaPixel } from "./utils/metaPixel";
import { installAddToCartClickTracker } from "./utils/addToCartTracker";
const __MP_CONTROLS = [{
  "id": "showStickyCta",
  "label": "Show Sticky Cta",
  "kind": "toggle",
  "group": "Options",
  "default": true
}, {
  "id": "debugPixel",
  "label": "Debug Pixel",
  "kind": "toggle",
  "group": "Options",
  "default": false
}];
function __mpIsValidControlValue(control, value) {
  if (control.kind === 'toggle') return typeof value === 'boolean';
  if (control.kind === 'number') {
    return typeof value === 'number' && Number.isFinite(value);
  }
  if (typeof value !== 'string' || value.length > 10000) return false;
  if (control.kind === 'select') {
    return control.options?.some(option => option.value === value) ?? false;
  }
  if (control.kind === 'color') {
    return /^#[0-9a-f]{6}$/i.test(value);
  }
  return true;
}
function __MPControlsRoot() {
  const [overrides, setOverrides] = __mpUseState({});
  __mpUseEffect(() => {
    const handleValues = event => {
      const nextValues = event.detail?.values;
      if (!nextValues || typeof nextValues !== 'object' || Array.isArray(nextValues)) {
        return;
      }
      const normalized = {};
      for (const control of __MP_CONTROLS) {
        const value = nextValues[control.id];
        if (__mpIsValidControlValue(control, value)) {
          normalized[control.id] = value;
        }
      }
      setOverrides(normalized);
    };
    const announceControls = () => {
      window.dispatchEvent(new CustomEvent('magicpatterns:controls-ready', {
        detail: {
          controls: __MP_CONTROLS
        }
      }));
    };
    window.addEventListener('magicpatterns:controls-values', handleValues);
    window.addEventListener('magicpatterns:controls-request', announceControls);
    announceControls();
    return () => {
      window.removeEventListener('magicpatterns:controls-values', handleValues);
      window.removeEventListener('magicpatterns:controls-request', announceControls);
    };
  }, []);
  return <App {...overrides} />;
}
const PAGE_TITLE = "Curly Seducción – Método para rizos definidos";
document.title = PAGE_TITLE;
let ogTitle = document.querySelector<HTMLMetaElement>('meta[property="og:title"]');
if (!ogTitle) {
  ogTitle = document.createElement("meta");
  ogTitle.setAttribute("property", "og:title");
  document.head.appendChild(ogTitle);
}
ogTitle.setAttribute("content", PAGE_TITLE);
initMetaPixel();
installAddToCartClickTracker();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<__MPControlsRoot />);
}